var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "app-modal",
    {
      staticClass: "register-modal",
      attrs: { shown: _vm.shown },
      on: { close: _vm.handleClose },
    },
    [
      _c("div", { staticClass: "center-register-modal" }, [
        _c("h1", [_vm._v(_vm._s(_vm.modalTitle))]),
        _vm._v(" "),
        _vm.errorMessages.main
          ? _c("div", { staticClass: "alert alert-danger" }, [
              _vm._v(_vm._s(_vm.errorMessages.main) + "\n    "),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "form",
          {
            staticClass: "form-horizontal register-form",
            attrs: { name: "form", role: "form" },
            on: {
              submit: function ($event) {
                $event.preventDefault()
                return _vm.handleCreateAccount.apply(null, arguments)
              },
            },
          },
          [
            _c("div", { staticClass: "fields-line" }, [
              _c(
                "div",
                { staticClass: "field-item" },
                [
                  _c("a-input", {
                    attrs: {
                      value: _vm.firstName,
                      label: "Name*",
                      name: "firstName",
                      required: _vm.isRequiredMessageShown("firstName"),
                    },
                    on: { input: _vm.updateRegistrationData },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "field-item" },
                [
                  _c("a-input", {
                    attrs: {
                      value: _vm.familyName,
                      label: "Last Name*",
                      name: "familyName",
                      required: _vm.isRequiredMessageShown("familyName"),
                    },
                    on: { input: _vm.updateRegistrationData },
                  }),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _vm.modalData.mode !== "invite"
              ? _c("div", { staticClass: "fields-line" }, [
                  _c(
                    "div",
                    { staticClass: "field-item" },
                    [
                      _c("a-input", {
                        attrs: {
                          value: _vm.email,
                          label: "Email*",
                          name: "email",
                          error: _vm.errorMessages.email,
                          required: _vm.isRequiredMessageShown("email"),
                        },
                        on: { input: _vm.updateRegistrationData },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "field-item" },
                    [
                      _c("a-input", {
                        attrs: {
                          value: _vm.confirmEmail,
                          label: "Confirm Email*",
                          name: "confirmEmail",
                          required: _vm.isRequiredMessageShown("confirmEmail"),
                          error: _vm.errorMessages.confirmEmail,
                        },
                        on: { input: _vm.updateRegistrationData },
                      }),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.modalData.mode === "invite"
              ? _c("div", { staticClass: "fields-line" }, [
                  _c("div", { staticClass: "field-item preselected-block" }, [
                    _c("span", { staticClass: "preselected-label" }, [
                      _vm._v("\n            Email*\n          "),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "preselected-data" }, [
                      _vm._v(
                        "\n            " + _vm._s(_vm.email) + "\n          "
                      ),
                    ]),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "fields-line" }, [
              _c(
                "div",
                { staticClass: "field-item" },
                [
                  _c("a-input", {
                    attrs: {
                      value: _vm.password,
                      label: "Password*",
                      name: "password",
                      mode: "password",
                      required: _vm.isRequiredMessageShown("password"),
                      error: _vm.errorMessages.password,
                    },
                    on: { input: _vm.updateRegistrationData },
                  }),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "fields-line" }, [
              _c(
                "div",
                { staticClass: "field-item" },
                [
                  _c("a-input-search", {
                    ref: "companyName",
                    staticClass: "a-search",
                    attrs: {
                      value: _vm.organisation,
                      options: _vm.searchCompanies,
                      "option-key": "displayName",
                      "option-label": "displayName",
                      label: "Organisation*",
                      required: _vm.isRequiredMessageShown("organisation"),
                      isCard: true,
                    },
                    on: { input: _vm.updateCompanyName },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "field-item" },
                [
                  _c("a-select", {
                    staticClass: "a-select",
                    attrs: {
                      value: { name: _vm.sector },
                      name: "sector",
                      options: _vm.sectorOptions,
                      "option-key": "name",
                      "option-label": "name",
                      label: "Business Sector*",
                      required: _vm.isRequiredMessageShown("sector"),
                      isAutofocus: false,
                    },
                    on: { input: _vm.updateRegistrationData },
                  }),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "fields-line" }, [
              _c(
                "div",
                { staticClass: "field-item field-item-wide" },
                [
                  _c("app-checkbox", {
                    attrs: {
                      value: _vm.acceptTerms,
                      name: "acceptTerms",
                      label:
                        'I accept Asoko Insight <a href="/about/legal" target="_blank">Terms & Conditions.</a><span>&ast;</span>',
                    },
                    on: { change: _vm.updateRegistrationData },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "field-item field-item-wide" },
                [
                  _c("app-checkbox", {
                    attrs: {
                      value: _vm.newsletter,
                      name: "newsletter",
                      label: "Receive weekly newsletter",
                    },
                    on: { change: _vm.updateRegistrationData },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "field-item" }, [
                _c("label", [
                  _vm._v("Fields above marked "),
                  _c("span", [_vm._v("*")]),
                  _vm._v(" are required."),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _vm.modalData.mode !== "invite"
              ? _c(
                  "div",
                  { staticClass: "recaptcha-wrap" },
                  [
                    _c("vue-recaptcha", {
                      attrs: { sitekey: _vm.sitekey },
                      on: {
                        verify: _vm.setRecaptcha,
                        expired: function ($event) {
                          _vm.recaptcha = ""
                        },
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "form-actions" }, [
              _c(
                "button",
                {
                  staticClass: "cta-button",
                  attrs: { type: "submit", disabled: _vm.isLoading },
                },
                [_vm._v("Create\n        ")]
              ),
              _vm._v(" "),
              _vm.modalData.mode !== "invite"
                ? _c(
                    "a",
                    {
                      staticClass: "btn btn-link",
                      on: { click: _vm.displayLogin },
                    },
                    [_vm._v("Login as Existing User\n        ")]
                  )
                : _vm._e(),
            ]),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }